import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import V2Layout from "@/pages/v2/V2Layout";
import Seo from "@/components/Seo";

export default function V2About() {
  return (
    <V2Layout>
      <div data-testid="v2-about">
        <Seo title="About WHO · Warm Hand Off" path="/v2/about" description="WHO — Warm Hand Off LLC is a veteran-serving initiative and emerging technology company building stronger connections between veterans and the organizations that serve them." />
        <section className="py-16 lg:py-24 bg-white border-b border-borderSubtle">
          <div className="max-w-[760px] mx-auto px-5 lg:px-8">
            <p className="eyebrow text-gold-deep">About WHO</p>
            <h1 className="mt-3 font-display font-black text-navy tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-tight" data-testid="v2-about-title">
              One Connection. One Veteran. One Family. One Community at a Time.
            </h1>
            <div className="mt-6 space-y-4 text-slateSoft leading-relaxed">
              <p>
                Warm Hand Off LLC (WHO) is a veteran-serving initiative and an emerging technology company.
                We believe the hardest part of getting help is rarely the help itself — it is the handoffs
                between the people and organizations providing it.
              </p>
              <p>
                WHO is developing ways to make those handoffs warmer: clearer information today, and a
                planned coordination approach designed around permission, confirmed connections, and
                follow-through.
              </p>
              <p>
                We work alongside — never instead of — the organizations already serving veterans with
                extraordinary commitment.
              </p>
            </div>
            <div className="mt-8 flex flex-wrap gap-6">
              <Link to="/founder" className="inline-flex items-center gap-1.5 text-navy font-semibold underline decoration-gold underline-offset-4 hover:text-gold-deep transition-colors" data-testid="v2-about-founder-link">
                Meet our founder <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/v2/approach" className="inline-flex items-center gap-1.5 text-navy font-semibold underline decoration-gold underline-offset-4 hover:text-gold-deep transition-colors" data-testid="v2-about-approach-link">
                Our approach <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </section>
      </div>
    </V2Layout>
  );
}
